export const colors = {
  B: {
    FR: 'Bleu',
    EN: 'Blue',
  },
  C: {
    FR: 'Marron',
    EN: 'Brown',
  },
  E: {
    FR: 'Beige',
    EN: 'Beige',
  },
  G: {
    FR: 'Gris',
    EN: 'Grey',
  },
  K: {
    FR: 'Rose',
    EN: 'Pink',
  },
  N: {
    FR: 'Noir',
    EN: 'Black',
  },
  O: {
    FR: 'Orange',
    EN: 'Orange',
  },
  P: {
    FR: 'Violet',
    EN: 'Purple',
  },
  R: {
    FR: 'Rouge',
    EN: 'Red',
  },
  W: {
    FR: 'Blanc',
    EN: 'White',
  },
  V: {
    FR: 'Vert',
    EN: 'Green',
  },
  Y: {
    FR: 'Jaune',
    EN: 'Yellow',
  },
}
